import { querySpecialOffer } from "./queries/querySpecialOffer"
import { querySpecialOffers } from "./queries/querySpecialOffers"
import { typeSpecialOffer } from "./specialOffer"

const specialOfferSchema = {
  types: [typeSpecialOffer],
  resolvers: {
    Query: { ...querySpecialOffer, ...querySpecialOffers },
    Mutation: {},
  },
}

export default specialOfferSchema
